// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "calculatormessages_content__bxxzt";
var _3 = "640px";
var _4 = "790px";
var _5 = "#057676";
var _6 = "#434343";
var _7 = "79px";
var _8 = "110px";
var _9 = "72px";
var _a = "665px";
var _b = "teal";
var _c = "calculatormessages_text__4oykl";
var _d = "2";
var _e = "#cdd3dc";
var _f = "calculatormessages_title__pibst";
var _10 = "calculatormessages_wrapper__aztvl";
export { _1 as "body", _2 as "content", _3 as "controlsMobileWidth", _4 as "controlsStackedWidth", _5 as "darkTeal", _6 as "headline", _7 as "menuHeight", _8 as "menuHeightLarge", _9 as "menuHeightMobile", _a as "modalMobileWidth", _b as "teal", _c as "text", _d as "timelineStrokeWidth", _e as "timelineTrackColor", _f as "title", _10 as "wrapper" }
